import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;

        if (!hash || !hash.includes('session_id=')) {
          setError('No session data received from Google. Please try again.');
          setTimeout(() => navigate('/login'), 2000);
          return;
        }

        const sessionId = hash.split('session_id=')[1].split('&')[0];

        // Exchange session_id for user data
        const response = await axios.post(
          `${BACKEND_URL}/api/auth/session?session_id=${sessionId}`
        );

        // Store session token for Bearer auth
        if (response.data.session_token) {
          localStorage.setItem('session_token', response.data.session_token);
        }

        // Clear hash and navigate to main app with user data
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/app', { state: { user: response.data.user }, replace: true });
      } catch (err) {
        const msg = err.response?.data?.detail || 'Login failed. Please try again.';
        setError(msg);
        toast.error(msg);
        setTimeout(() => navigate('/login'), 2500);
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#F8F6F1] flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-50 flex items-center justify-center">
              <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.072 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg>
            </div>
            <p className="font-sans text-[#C67B5C] text-base mb-2">{error}</p>
            <p className="font-sans text-[#A0AEC0] text-sm">Redirecting to login...</p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 border-4 border-[#7A9B7E] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="font-sans text-[#7A8A7A] text-lg">Signing you in...</p>
            <p className="font-sans text-[#A0AEC0] text-sm mt-2">Please wait</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
